import React from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Box, IconButton, useMediaQuery, useTheme, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';
import { logout } from '../services/authService';
import ProfileDropdown from './ProfileDropdown';
import LanguageSwitcher from '../components/LanguageSwitcher';
import { PointOfSale as PointOfSaleIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useModulePermissions } from '../hooks/useModulePermissions';

const TopNav = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { t } = useTranslation();
  const { canViewModule } = useModulePermissions();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        zIndex: (theme) => theme.zIndex.drawer + 1,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        backdropFilter: 'blur(10px)',
        ml: { md: '240px' },
        width: { md: 'calc(100% - 240px)' },
      }}
    >
      <Toolbar sx={{ minHeight: { xs: 64, sm: 70 }, px: { xs: 2, sm: 3 } }}>
        {isMobile && (
          <IconButton
            color="inherit"
            edge="start"
            onClick={onMenuClick}
            sx={{ 
              mr: 2,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              }
            }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Box 
          sx={{ 
            display: "flex", 
            alignItems: "center", 
            gap: { xs: 1, sm: 2 },
          }}
        >
          {/* POS Button - Only show if user has POS module view permission */}
          {canViewModule('POS') && (
            <Button
              color="inherit"
              startIcon={<PointOfSaleIcon />}
              onClick={() => navigate('/pos')}
              sx={{
                mr: 2,
                px: 2,
                py: 1,
                borderRadius: '8px',
                textTransform: 'none',
                fontWeight: 600,
                fontSize: '0.95rem',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                }
              }}
            >
              {t('pos') || 'POS'}
            </Button>
          )}
          
          <LanguageSwitcher />
          <ProfileDropdown />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNav;